<template>
  <div class="customer-container">
    <div class="searchArea">
      <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 10px;">

        <a-select v-model:value="searchParams.clubId" placeholder="请选择门诊" style="width: 180px; margin-right: 16px;" allowClear>
          <a-select-option v-for="item in clubList" :key="item.id" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>

        <a-input v-model:value="searchParams.diseaseName" placeholder="病种" style="width: 180px; margin-right: 16px;" @pressEnter="handleSearch" />
        <a-input v-model:value="searchParams.name" placeholder="姓名" style="width: 180px; margin-right: 16px;" allowClear @pressEnter="handleSearch" />
        <a-input v-model:value="searchParams.mobile" placeholder="手机号" style="width: 180px; margin-right: 16px;" allowClear @pressEnter="handleSearch" />

        <a-button type="primary" shape="circle" @click="handleSearch">
          <template #icon>
            <SearchOutlined />
          </template>
        </a-button>
        <a-button style="margin-left: 8px;" @click="resetSearch">重置</a-button>
      </div>
    </div>

    <a-table class="ant-table-striped" :columns="columns" :data-source="list" :loading="loading" row-key="mobile" :pagination="{ pageSize: 8 }" bordered>
      <template v-for="col in ['visitInfo']" #[col]="{ column, record }" :key="col">
        <div>次数: {{ record?.visitCount || 0 }}</div>
        <div style="font-size: 12px; color: #999;">
          时间: {{ record?.latestVisitDate || '--' }}
        </div>
      </template>

      <template v-for="col in ['balanceInfo']" #[col]="{ column, record }" :key="col">
        <div v-for="(item, index) in record?.memberships || []" :key="index">
          {{ item?.serviceCardName || '' }}: {{ item?.amountLeft || 0 }}
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
import { SearchOutlined } from '@ant-design/icons-vue';
import { GetCustomerListByDisease } from '@/api/customer';
import { ClubList } from '@/api/businessManage/summary.js';

export default {
  name: 'CustomerSearch',
  components: {
    SearchOutlined
  },
  data() {
    return {
      loading: false,
      list: [],
      clubList: [],
      searchParams: {
        clubId: undefined,
        diseaseName: '',
        name: '',
        mobile: ''
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true
      },
      columns: [
        { title: '姓名', dataIndex: 'name', key: 'name' },
        { title: '手机号', dataIndex: 'mobile', key: 'mobile' },
        { title: '微信昵称', dataIndex: 'nickName', key: 'nickName' },
        { title: '就诊次数以及最近就诊时间', key: 'visitInfo', slots: { customRender: 'visitInfo' } },
        { title: '积分/充值余额', key: 'balanceInfo', slots: { customRender: 'balanceInfo' } },
        { title: '消费记录', dataIndex: 'consumptionRecord', key: 'consumptionRecord' },
        { title: '挂号未到店次数', dataIndex: 'noShowCount', key: 'noShowCount' },
        { title: '主动取消次数', dataIndex: 'cancelCount', key: 'cancelCount' }
      ]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await this.getClubList();
    },
    async getClubList() {
      try {
        const res = await ClubList();
        if (res.errCode === 0) {
          this.clubList = res.data.map(item => ({
            ...item,
            id: item.id || item.clubId,
            name: item.name || item.clubName,
          }));

          if (this.clubList.length === 1) {
            this.searchParams.clubId = this.clubList[0].id;
          }
        } else {
          this.$message.error(res.message || '获取门店列表失败');
        }
      } catch (error) {
        console.error(error);
        this.$message.error('获取门店列表网络异常');
      }
    },
    async fetchData() {
      // 疾病名必填校验（去除首尾空格）
      const diseaseNameVal = this.searchParams.diseaseName?.trim();
      if (!diseaseNameVal) {
        this.$message.warning('请填写病种名称');
        return;
      }

      this.loading = true;
      try {
        const params = {
          ...this.searchParams,
          diseaseName: diseaseNameVal, // 传递去除首尾空格后的病种名
        };
        const res = await GetCustomerListByDisease(params);
        this.list = res?.data || [];
      } catch (error) {
        console.error(error);
        this.$message.error('数据加载失败');
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.pagination.current = 1;
      this.fetchData();
    },
    resetSearch() {
      // 重置搜索条件（保留单门店默认选中逻辑）
      this.searchParams = {
        clubId: this.clubList.length === 1 ? this.clubList[0].id : undefined,
        diseaseName: '',
        name: '',
        mobile: ''
      };
      // 清空表格数据并重置分页
      this.list = [];
      this.pagination.current = 1;
      // 注意：不自动调用 handleSearch()，必须由用户输入疾病名后手动搜索
    },
  }
};
</script>

<style scoped>
</style>